import { createApp } from 'vue'
import router from './router'
import auth from './auth'
import App from './App.vue'
import axios from 'axios'
import wsocket from './wsocket'
import VueAxios from 'vue-axios'

createApp(App).use(router).use(auth).use(VueAxios, axios).use(wsocket).mount('#app')
